import React, {Suspense} from 'react'

//Hall Assets
import LeftWall from "../Walls/LeftWall"
import RightWalln from "../Walls/RightWalln"
import FrontWall from '../Walls/FrontWall'
import Ground from '../Floor/Ground'
import SideBoundary from '../Walls/SideBoundary'
import WalkableArea from '../Floor/WalkableArea'
import Carpet from "../Carpet/Carpet"
import Sign from "../Sign/Sign"
import Door from "../Door/Door"
import Ceiling from "../Ceiling/Untitled"
import TeleportMarker from '../Marker/TeleportMarker'
// import FPSNew from '../../Player/FPSNew'
import Firstpersonprespective from '../../Player/Firstpersonprespective'

//Stalls
const Type1Center = React.lazy(() => import('./Stall/Type1_Center'))
const Type1Corner = React.lazy(() => import('./Stall/Type1_corner'))
const Type2Center = React.lazy(() => import('./Stall/Type2_Center'))
const Type2Corner = React.lazy(() => import('./Stall/Type2_corner'))
const Type3Corner = React.lazy(() => import('./Stall/Type3_corner'))
const Type3Center = React.lazy(() => import('./Stall/Type3_center'))

//physics
const Collision = React.lazy(() => import('./Collision/Collision'))
const Collider = React.lazy(() => import('./Collider'))
const TotamPhysics = React.lazy(() => import('../Brandings/TotamPhysics'))

//stall assets
const ReceptionTable = React.lazy(() => import("./ReceptionTable/ReceptionDraco"))
const Reception2 = React.lazy(() => import("./ReceptionTable/Reception2"))
const Broucher = React.lazy(() => import("./Broucher/Broucher"))
const VCTable = React.lazy(() => import("./VCTable/VCTable"))
const KTv = React.lazy(() => import("./KTv/KTv"))
const Display = React.lazy(() => import("./Display/Display"))
const Banners = React.lazy(() => import('./Logo/Banners'))
const Standee = React.lazy(() => import("./Standee/Standee"))
const StallsLight = React.lazy(() => import('./StallsLight/StallsLight'))
const Hotspot = React.lazy(() => import('../../Hotspot/Hotspot'))
const VCStand = React.lazy(() => import("./VCStand/VCStand"))
const Totam = React.lazy(() => import("../Brandings/Totam"))
const SponsorBanner = React.lazy(() => import('../Brandings/SponsorBanner'))
const HangingFlexes = React.lazy(() => import('../Brandings/HangingFlexes'))

const Hall = ({positionData, floorSize, hotspotData, sponsorsData, stallData, browser, isMobile}) => {


    console.log(isMobile)

    return (
        <>
            <Ground size={floorSize} />
            <WalkableArea size={floorSize} />
            {/* <Ceiling size={floorSize} /> */}
            <LeftWall size={floorSize} position={[0, 0, -125]} />
            <FrontWall size={floorSize} />
            <RightWalln size={floorSize} position={[0, 0, 123]} />
            {/* <Carpet size={floorSize} /> */}
            {/* <SideBoundary size={floorSize} /> */}
            {/* <Door size={floorSize} /> */}
            {/* <Sign size={floorSize} /> */}
            {/* <TeleportMarker/> */}
            <Firstpersonprespective/>

            { browser === 'chrome' || browser === 'edge' ? (
                <>
                    {/* <Collider data={positionData} />
                    <Collision data={positionData} instanceSize={stallData.length} />
                    <TotamPhysics size={floorSize} /> */}
                    {/* <Type1Center positionData={positionData["type1-center"].pos} color={positionData["type1-center"].color} />
                    <Type1Corner positionData={positionData["type1-corner"].pos} color={positionData["type1-corner"].color} /> */}
                    <Type2Center positionData={positionData["type2-center"].pos} color={positionData["type2-center"].color} />
                    {/* <Type2Corner positionData={positionData["type2-corner"].pos} color={positionData["type2-corner"].color} />
                    <Type3Center positionData={positionData["type3-center"].pos} color={positionData["type3-center"].color} />
                    <Type3Corner positionData={positionData["type3-corner"].pos} color={positionData["type3-corner"].color} /> */}
                    {/* <VCTable data={positionData} />
                    <StallsLight data={positionData} />
                    <Broucher data={positionData} instanceSize={stallData.length} />
                    <Reception2 data={positionData} instanceSize={stallData.length} />
                    <Display data={positionData} />
                    <Banners data={positionData} />
                    <Hotspot data={positionData} hotspotData={hotspotData} />
                    <VCStand data={positionData} />
                    <KTv data={positionData} />
                    <Standee data={positionData} />
                    <ReceptionTable data={positionData} instanceSize={stallData.length} />
                    <Totam size={floorSize} sponsorsData={sponsorsData} />
                    <SponsorBanner size={floorSize} sponsorsData={sponsorsData} />
                    <HangingFlexes stallData={positionData} sponsorsData={sponsorsData} /> */}
                </>
            ) : (
            <>
                <React.SuspenseList revealOrder="forwards">
                        {/* <Suspense fallback={null}>
                            <Collider data={positionData} />
                        </Suspense>
                        <Suspense fallback={null} >
                            <Collision data={positionData} instanceSize={stallData.length} />
                        </Suspense>
                        <Suspense fallback={null} >
                            <TotamPhysics size={floorSize} />
                        </Suspense> */}
                        {/* <Suspense fallback={null}>
                            <Type1Center positionData={positionData["type1-center"].pos} color={positionData["type1-center"].color} />
                        </Suspense>
                        <Suspense fallback={null}>
                            <Type1Corner positionData={positionData["type1-corner"].pos} color={positionData["type1-corner"].color} />
                        </Suspense> */}
                        <Suspense fallback={null}>
                            <Type2Center positionData={positionData["type2-center"].pos} color={positionData["type2-center"].color} />
                        </Suspense>
                        {/* <Suspense fallback={null}>
                            <Type2Corner positionData={positionData["type2-corner"].pos} color={positionData["type2-corner"].color} />
                        </Suspense>
                        <Suspense fallback={null}>
                            <Type3Center positionData={positionData["type3-center"].pos} color={positionData["type3-center"].color} />
                        </Suspense>
                        <Suspense fallback={null}>
                            <Type3Corner positionData={positionData["type3-corner"].pos} color={positionData["type3-corner"].color} />
                        </Suspense> */}
                        {/* <Suspense fallback={null}>
                            <Broucher data={positionData} instanceSize={stallData.length} />
                        </Suspense>
                        <Suspense fallback={null}>
                            <Display data={positionData} />
                        </Suspense>
                        <Suspense fallback={null}>
                            <VCTable data={positionData} />
                        </Suspense>
                        <Suspense fallback={null}>
                            <StallsLight data={positionData} />
                        </Suspense>
                        <Suspense fallback={null}>
                            <Reception2 data={positionData} instanceSize={stallData.length} />
                        </Suspense>
                        <Suspense fallback={null}>
                            <Banners data={positionData} />
                        </Suspense>
                        <Suspense fallback={null}>
                            <Hotspot data={positionData} hotspotData={hotspotData} />
                        </Suspense>
                        <Suspense fallback={null}>
                            <VCStand data={positionData} />
                        </Suspense>
                        <Suspense fallback={null}>
                            <KTv data={positionData} />
                        </Suspense>
                        <Suspense fallback={null}>
                            <Standee data={positionData} />
                        </Suspense>
                        <Suspense fallback={null} >
                            <ReceptionTable data={positionData} instanceSize={stallData.length} />
                        </Suspense>
                        <Suspense fallback={null}>
                            <Totam size={floorSize} sponsorsData={sponsorsData} />
                        </Suspense>
                        <Suspense fallback={null}>
                            <SponsorBanner size={floorSize} sponsorsData={sponsorsData} />
                        </Suspense>
                        <Suspense fallback={null}>
                            <HangingFlexes stallData={positionData} sponsorsData={sponsorsData} />
                        </Suspense> */}
                </React.SuspenseList>
            </>
            )}          
        </>
    )
}

export default Hall



{/*  */}